module.exports = MaterialUI.MenuItem;